import styled from 'styled-components';

import { modularScale } from '../../utils';

export const Label = styled.label`
  font-weight: 700;
  font-size: ${modularScale()};
`;
